import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import Icon from '../../core/components/Icon'
import TodoStatusIcon from '../../workflow/components/TodoStatusIcon'
import {logout} from '../actions'
import i18n from '../i18n'
import style from './UserNavItem.less'
import AdditionalContextButton from '../../app/components/AdditionalContextButton'

class UserNavItem extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired
    }

    _logout(event) {
        const {dispatch} = this.props

        event.preventDefault()

        dispatch(logout()).then(() => {
            // reload to discard app state
            window.location = '/login'
        })
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
        const {dispatch, user} = this.props
        
        const tooltip = (text, style) => (
            <Tooltip
                className={style && ('tooltip-' + style)}>
                {text}
            </Tooltip>
        )

        return (
            <div className={style.default}>
                <div className={style.side}>
                    <a
                        className={style.user}
                        href=''
                        onClick={(e) => this._navigate(e, '/todolist')}>
                        <TodoStatusIcon
                            user={user}
                            icon='user'
                            size='md' />
                    </a>
                    <OverlayTrigger
                        placement='bottom'
                        overlay={tooltip(i18n.manageAccount)}>
                        <a
                            href=''
                            onClick={(e) => this._navigate(e, '/account')}>
                            <Icon icon='cog' size='xs' />
                        </a>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement='bottom'
                        overlay={tooltip(i18n.signout, 'danger')}>
                        <a
                            href=''
                            onClick={(e) => this._logout(e)}>
                            <Icon icon='sign-out' size='xs' />
                        </a>
                    </OverlayTrigger>
                </div>
                <div className={style.container}>
                    <p className={style.name}>{user.firstName} {user.lastName}</p>
                    <p className={style.job}>{user.job}</p>
                    <AdditionalContextButton/>
                </div>
            </div>
        )
    }
}

UserNavItem = connect((state) => ({
    user: state.user.authenticated
}))(UserNavItem)

export default UserNavItem


// WEBPACK FOOTER //
// ./lib/user/components/UserNavItem.js